export default "__VITE_ASSET__BxerbnZ$__"